export class Cart {
  constructor() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.getCart = this.getCart.bind(this);
    this.add = this.add.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.build = this.build.bind(this);
    this.addSecondary = this.addSecondary.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  /**
   * Opens the cart drawer
   * @return {void}
   */
  open() {
    $('body').addClass('no-scroll');
    $('#drawer-cart').addClass('is-active');
  }

  /**
   * Closes the cart drawer
   * @return {void}
   */
  close() {
    $('body').removeClass('no-scroll');
    $('#drawer-cart').removeClass('is-active');
  }

  /**
   * Get the cart and update the cart items counter
   * @return {void}
   */
  getCart() {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success(res) {
        if(res.item_count > 0){
          $('.js-cart-count').removeClass('hidden');
        } else {
          $('.js-cart-count').addClass('hidden');
        }

        $('.js-cart-count').text(res.item_count);
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Build cart items
   * @return {void}
   */
  build() {
    $.ajax({
      context: this,
      type: 'GET',
      dataType: 'html',
      success(res) {
        const $cartItems = $(res).find('#drawer-cart');

        $('#drawer-cart').empty();
        $($cartItems.html()).appendTo('#drawer-cart');

        $('.js-ajax-add').removeClass('btn--loading');
        $('.js-cart-items-holder').removeClass('is-busy');

        this.open();
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Add item(s) to the cart, update it and open it
   * @param {Array} items An array holding the object(s) with item properties. Example: [{ 33501660184709, 1 }, { 33501234593925, 3 }]
   * @return {void}
   */
  add(items) {
    $.ajax({
      url: '/cart/add.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { items },
      success(res) {
        this.getCart();
        this.build();
      },
      error(err) {
        alert(err.responseJSON.description);
        $('.js-ajax-add').removeClass('btn--loading');
      },
    });
  }

  /**
   * Add item(s) to the cart with subscription included, update it and open it
   * @param {String} form string containing serialized form.
   * @return {void}
   */
  addSecondary(form){
    const serializeForm = form.serialize();

    $.ajax({
      url: '/cart/add.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: serializeForm,
      success(res) {
        this.getCart();
        this.build();
      },
      error(err) {
        alert(err.responseJSON.description);
        $('.js-ajax-add').removeClass('btn--loading');
      },
    });    
  }

  /**
   * Update item from the cart
   * @param  {Integer} quantity Quantity of the updated item. 0 for item removal.
   * @param  {Integer} id       The key of the line item.
   * @return {void}
   */
  updateItem(quantity, id) {
    $.ajax({
      url: '/cart/change.js',
      context: this,
      dataType: 'json',
      data: {
        quantity,
        id,
      },
      success(res) {
        this.getCart();
        this.build();
      },
      error(err) {
        $('.js-table-product').slideDown();
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Remove item from the cart
   * @param  {Integer} line the position of the cart item.
   * @return {void}
  */
  removeItem(line){
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      context: this,
      data: 'quantity=0&line=' + line,
      dataType: 'json',
      success(res) {
        this.getCart();
        this.build();
      },
      error(err) {
        $('.js-table-product').slideDown();
        alert(err.responseJSON.description);
      },
    });     
  }
}
